import { BrowserRouter, Switch, Route, HashRouter } from 'react-router-dom';

import React, { Component } from 'react';
import NotFound from 'NOTICEBOARD/CommonResources/NotFound/NotFound';
import NoticeList from 'NOTICEBOARD/Components/NoticeList/NoticeList';
import NoticeDetails from 'NOTICEBOARD/Components/NoticeDetails/NoticeDetails';

export class RoutesSetup extends Component {
    render() {
        return (
            <>
                <HashRouter>
                    <Switch>
                        <Route exact path="/:instituteUrl" component={NoticeList} />
                        <Route path="/:instituteUrl/:noticeId" component={NoticeDetails} />
                        <Route path="*" component={NotFound} />
                    </Switch>
                </HashRouter>
            </>
        )
    }
}

export default RoutesSetup;
